import { IntlProvider as ReactIntlProvider } from "react-intl";

import { DEFAULT_LOCALE } from "@/locale";

import type { ReactNode } from "react";
import type { LocaleKey, Messages } from "@/locale";

type IntlProviderProps = {
  children: ReactNode;
  locale: LocaleKey;
  messages: Messages;
};

export function IntlProvider({ children, locale, messages }: IntlProviderProps) {
  return (
    <ReactIntlProvider locale={locale} defaultLocale={DEFAULT_LOCALE} messages={messages}>
      {children}
    </ReactIntlProvider>
  );
}
